import storage from 'src/services/storage';

export default () => {
  storage.onReady(
    /** @param {import('src/types/store').RootStore} store **/ (store) => {
      const typeFilterString = storage.get('events/typeFilter');
      if (typeFilterString) {
        try {
          const typeFilter = JSON.parse(typeFilterString);
          if (typeFilter) {
            store.commit('events/setTypeFilter', typeFilter);
          }
        } catch {
          // do nothing
        }
      }

      const vehicleFilter = storage.get('events/vehicleFilter');
      if (vehicleFilter) {
        store.commit('events/setVehicleFilter', vehicleFilter);
      }

      const driverFilter = storage.get('events/driverFilter');
      if (driverFilter && store.state.users.users[driverFilter]) {
        // Only set the driver filter if the user exists
        store.commit('events/setDriverFilter', driverFilter);
      }

      const dateRangeFilterString = storage.get('events/dateRangeFilter');
      if (dateRangeFilterString) {
        try {
          const dateRangeFilter = JSON.parse(dateRangeFilterString);
          if (dateRangeFilter) {
            store.commit('events/setDateRangeFilter', dateRangeFilter);
          }
        } catch {
          // do nothing
        }
      }
    }
  );

  return {
    activityAreaHeight: 0,
    /** @type {import('src/types/events-feed').EventType[]} */
    typeFilter: [],
    /** @type {[string, string] | null} */
    dateRangeFilter: null,
    didLoad: false,
    driverFilter: '',
    /** @type {import('src/types/events-feed').EventsFeedItem[]} */
    events: [],
    eventsCursor: '',
    hasLoadedAll: false,
    isApplying: false,
    isLoading: false,
    isLoadingSingleEvent: false,
    /** @type {import('src/types/events-feed').EventsFeedItem} */
    selectedEvent: null,
    singleEvent: null,
    vehicleFilter: '',
  };
};
